module.exports = __webpack_public_path__ + "static/media/group-cover-4.d821a841.webp";